import * as allIcons from 'ionicons/icons';

import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';
import { StatusBar, Style } from '@capacitor/status-bar';

import { Component } from '@angular/core';
import { LoadScriptService } from './core/services/load-script/load-script.service';
import { NgIf } from '@angular/common';
import { NotificationService } from './core/services/notification/notification.service';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { addIcons } from 'ionicons';
import { environment } from '@env/environment';
import { initFlowbite } from 'flowbite';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [IonRouterOutlet, SharedModule, RouterOutlet, NgIf],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent {
	title = ' ';
	env: typeof environment = environment;

	/**
	 * Constructor.
	 */
	constructor(
		private LoadScript: LoadScriptService,
		private platform: Platform,
		private notificationService: NotificationService,
	) {
		addIcons(allIcons);
	}

	ngOnInit(): void {
		initFlowbite();
		this.LoadScript.loadAllScriptsFromJson();

		if (this.platform.is('hybrid')) {
			this.setColorStatusBar();
		}

		this.notificationService.startConnection();
	}
	private setColorStatusBar() {
		StatusBar.setBackgroundColor({
			color: '#ffffff',
		}).then((res) => { });
		StatusBar.setStyle({ style: Style.Default });
	}

	public isDevelopmentOrStaging(): boolean {
		// return !this.env.production || this.env.name === 'staging';
		return false;
	}
}

